import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { Item } from './Item';
import { Person } from './Person';

export interface Issue extends Item {
  submitterId: number;
  submitter?: Person;

  topic?: string;
  issue: string;
  courseSectionId?: number;
}

export const translateIssueFromTransport = (attributes: any): any => {
  return {
    ...attributes,
    issue: isBase64(attributes.issue) ? base64Decode(attributes.issue) : attributes.issue,
  };
};

export const translateIssueForTransport = (attributes: any): any => {
  return {
    ...attributes,
    issue: !isBase64(attributes.issue) ? base64Encode(attributes.issue) : attributes.issue,
  };
};
